"use strict";const e=require("amplitude-js");var t={install:(t,{apiKey:i,userId:s,config:r})=>{e.getInstance().init(i,s,r),t.prototype.$amplitude=e}};module.exports=t;
